import { Inject, Injectable } from '@angular/core'
import { ENVIRONMENT, Environment } from '@evologi/shared/data-access-api'
import { buildHandoffUrl } from '@evologi/shared/auth-store'

@Injectable({ providedIn: 'root' })
export class VersionRoutingService {
  private static readonly LEGACY_QUERY = 'legacy'
  private static readonly LEGACY_KEY = 'disable-redirect'

  constructor(@Inject(ENVIRONMENT) private env: Environment) {}

  /** Runs once at bootstrap, before any user is resolved. */
  consumeLegacyParam(): void {
    const params = new URLSearchParams(window.location.search)
    if (params.get(VersionRoutingService.LEGACY_QUERY) !== '1') {
      return
    }

    this.setLegacy()
    params.delete(VersionRoutingService.LEGACY_QUERY)

    const q = params.toString()
    const path = `${window.location.pathname}${q ? `?${q}` : ''}${window.location.hash}`
    window.history.replaceState(null, '', path)
  }

  redirectIfNeeded(userId: string): void {
    const freshUserIds = this.env.freshUserIds
    if (!freshUserIds?.length) {
      return
    }

    const freshUrl = 'https://fresh.orderpod.app/'
    const stillUrl = 'https://orderpod.app/'

    const onFresh =
      this.env.configuration === 'fresh' ||
      this.normalize(window.location.origin) === this.normalize(freshUrl)

    if (!freshUserIds.includes(userId)) {
      if (onFresh) {
        window.location.href = buildHandoffUrl(stillUrl)
      }
      return
    }

    if (this.isLegacy() || onFresh) {
      return
    }

    window.location.href = buildHandoffUrl(freshUrl)
  }

  private setLegacy(): void {
    try {
      localStorage.setItem(VersionRoutingService.LEGACY_KEY, '1')
    } catch {
      /* storage unavailable — user just won't persist the opt-out */
    }
  }

  private isLegacy(): boolean {
    try {
      return localStorage.getItem(VersionRoutingService.LEGACY_KEY) === '1'
    } catch {
      return false
    }
  }

  private normalize(url: string): string {
    return url.replace(/\/+$/, '')
  }
}
